export const recaptchaEnv = {
  recaptchaSiteKey: '6Le0aaIlAAAAAIGN6M90pr0DW9iCvNBUEXwAtS1u',
  gcpApiKey:'AIzaSyD6ECno50kHBMuUFL3EJqi3gcwBSFNUTh4',
};